import React from "react";

import "./logout.css";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import { useState } from "react";

import CloseIcon from "../../assets/icon/close-icon.png";
import { DARK_BG, BLACK } from "../../utilities/colors";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: DARK_BG,
  border: `2px solid ${BLACK}`,
  boxShadow: 24,
  p: 4,
  background: `${DARK_BG} 0% 0 % no - repeat padding- box`,
  borderRadius: "16px",
  opacity: "1",
};

const Logout = ({ btnText }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  function logoutUser() {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/";
  }

  return (
    <div className="logout">
      <div>
        <Button onClick={handleOpen}>{btnText}</Button>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <div className="modal-close-icon">
                <img onClick={handleClose} src={CloseIcon} alt="" />
              </div>
              <div className="login-wrapper">
                <div className="login-header">
                  <h5>Are you sure you want to logout?</h5>
                  {/* <p>Save and track your predictions </p>
                  <p>Take on your friends</p> */}
                  <button className="logout-btn" onClick={logoutUser()}>LOGOUT</button>
                </div>
              </div>
            </Box>
          </Fade>
        </Modal>
      </div>
    </div>
  );
};

export default Logout;
